import { MaintenanceAlert } from "components/common";
import { SearchWithFilter } from "components/search";

const AdmPage = () => {
  return (
    <>
      <MaintenanceAlert />
      <SearchWithFilter />
    </>
  );
};

export default AdmPage;
